var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-option-group',_vm._l((_vm.dataList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }